import { render, staticRenderFns } from "./PopularRestaurants.vue?vue&type=template&id=78c522e6&lang=pug&"
import script from "./PopularRestaurants.vue?vue&type=script&lang=js&"
export * from "./PopularRestaurants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports